const manageFiles = require.context(".",true,/\.js$/);
let configRouter = [];
manageFiles.keys().forEach((key)=>{
	if(key === "./index.js") return;
	configRouter = configRouter.concat(manageFiles(key).default);
})
export default configRouter;